<template>
    <div id="loginContaier" :style="backgroundStyle">
        <img
            src="~assets/images/common/logo.png"
            alt=""
            class="schoolLogo"
        />
        <!-- <div style="width:52%;">
            <center><h1 class="type_1" style="font-size: 20px; font-weight: bold;color:#666">公需课学习说明</h1></center>
            <div class="path-course" style="line-height: 26px;margin:20px;font-size: 15px; color:#ff0000;font-weight: bold;">
                参加继续教育全体学员：<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;高峰期（9：30-10：30  15：00-16：00）
                在线学习人数较多并发量大，如登录或学习反应慢时，请大家安排时间错峰学习。<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请不要使用专业课系统账号密码登录。如果以
                前没有注册学习过（登录提示：数据库中没有您的信息。），请点击 新用户?请注册  来注册学习。如果忘记
                密码请点击 找回密码。<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;参加2024继续教育公需课全部学员必须通过自治
                区住建行业从业人员培训考核管理系统按照提示进行注册、登录、报名和学习后跳转到本站才能进行学习，否则
                无法正常登录，(地址:
                <a href="https://ksxt.lwglfw.cn:200/" style="color:#000">https://ksxt.lwglfw.cn:200/</a>)。
                盟市进行过专业课学习的学员，盟市学习主办方将学习信息上报至自治住建行业从业人员培训考核管理系统后，
                到管理系统注册、登录点击跳转至本站再进行学习。<br>
                <center><img src="@/assets/images/common/wxq.jpg" style="height:160px;"><br>技术服务微信</center>
            </div>
        </div> -->
        <div class="login">
            <div class="loginForm" style="width:100%">
                <div class="loginFormTitle">
                    <div>
                        <p>账号登录</p>
                        <span></span>
                    </div>
                </div>
                <div class="logonContent">
                    <el-form ref="loginForm" :model="loginForm" :rules="rules">
                        <el-form-item prop="username">
                            <el-input
                                placeholder="请输入用户名"
                                v-model="loginForm.username"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                                placeholder="请输入密码"
                                type="password"
                                v-model="loginForm.password"
                                show-password
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="veriCode">
                            <el-input placeholder="请输入短信验证码" v-model="loginForm.veriCode">
                                <span slot="append" style="cursor: pointer;" @click="sendSmsCode"
                                    v-if="!countDown">{{ countDown > 0 ? `${countDown}秒后重新发送` : '发送短信验证码' }}</span>
                                <span slot="append" style="cursor: not-allowed; color: #999;"
                                    v-else>{{ countDown }}秒后重新发送</span>
                            </el-input>
                        </el-form-item>
                        <span style="color:red;font-size: 12px;">{{ msg }}</span>
                        <el-form-item>
                            <div class="remember">
                                <!-- <el-checkbox v-model="loginForm.rememberMe"
                                    >记住用户名和密码</el-checkbox
                                > -->
                                <div class="relevantOperate">
                                    <span class="forget" @click="forgetPassWord"
                                        >忘记密码</span
                                    >
                                    <p>|</p>
                                    <span
                                        class="register"
                                        @click="enterRegister"
                                        >注册</span
                                    >
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                @click.native.prevent="handleLogin('loginForm')"
                                :disabled="isStatus"
                                >登录</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="link-container">
            <div class="index-banner-content">
                <div class="index-banner-nav">
                    <div class="index-b-nav active">
                        <img src="~assets/images/index/bNavImg1.png" alt="">
                        <img src="~assets/images/index/bNavLeftImg.png" alt="" style="display:block !important;" class="bNavLeftImg">
                        <span style="font-size:18px;">去学习其他课程</span>
                    </div>
                    <div class="index-b-nav" @click="enterWebsite('https://ksxt.lwglfw.cn:200/auth?redirect=/')">
                        <img src="~assets/images/index/bNavImg2.png" alt="">
                        <img src="~assets/images/index/bNavLeftImg.png" alt="" class="bNavLeftImg">
                        <span>住建行业从业人员培训考核信息管理系统</span>
                    </div>
                    <div class="index-b-nav" @click="enterWebsite('https://zyjj.imaa.edu.cn')">
                        <img src="~assets/images/index/bNavImg3.png" alt="">
                        <img src="~assets/images/index/bNavLeftImg.png" alt="" class="bNavLeftImg">
                        <span>内蒙古自治区专业技术人员<br>继续教育（建筑类专业）</span>
                    </div>
                    <div class="index-b-nav" @click="enterWebsite('https://pay.hyjylh.com')">
                        <img src="~assets/images/index/bNavImg4.png" alt="">
                        <img src="~assets/images/index/bNavLeftImg.png" alt="" class="bNavLeftImg">
                        <span>原八大员继续教育专业课</span>
                    </div>
                    <div class="index-b-nav" @click="enterWebsite('https://pth.imaa.edu.cn:443/')">
                        <img src="~assets/images/index/bNavImg8.png" alt="">
                        <img src="~assets/images/index/bNavLeftImg.png" alt="" class="bNavLeftImg">
                        <span>普通话培训</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 隐藏的图片容器 -->
        <el-image ref="previewImg" style="display: none" :src="srcList[0]" :preview-src-list="srcList" />
        <el-dialog
            :visible.sync="dialogVisible[index]"
            width="600"
            v-for="(item, index) in remindData"
            :key="item.id"
            append-to-body
        >
            <div style="font-size: 26px;font-weight: bold;margin-bottom:20px;" v-html="articleUnescapeHtml(item.remindTitle)"></div>
            <div style="line-height: 32px;" v-html="articleUnescapeHtml(item.remindContent)"></div>
        </el-dialog>
    </div>
</template>

<script>
import VueEvent from '@/VueEvent.js'
import { PcCookie, Key } from "@/utils/cookie";
import AES from '@/utils/cryptoAES.js'
import { getSystemRemind } from "@/api/article"
import { sendVeriCode } from "@/api/smsCode"
// import { unescapeHTML } from "utils/validate";
export default {
    computed: {
        backgroundStyle() {
            return {
                backgroundImage: `url(${this.backgroundImageUrl})`,
                backgroundSize: 'cover',
                height: '100vh',
            };
        },
        //文章转义字符
        articleUnescapeHtml() {
            return function (content) {
                // return unescapeHTML(content);
                const decoder = document.createElement('textarea');
                decoder.innerHTML = content;
                return decoder.value;
            };
        },
    },
    data() {
        return {
            isShow:false,
            url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            srcList: [
                'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
                'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
            ],
            backgroundImageUrl: require('@/assets/images/common/backImg.jpg'),
            //显示密码
            flag: false,
            isStatus: false,
            remindData:[],
            dialogVisible:false,
            //登录信息
            loginForm: {
                username:
                    PcCookie.get(Key.passKey) != undefined
                        ? PcCookie.get(Key.userInfoKey)
                        : "",
                password: PcCookie.get(Key.passKey) != undefined ? AES.decrypt(PcCookie.get(Key.passKey),PcCookie.get(Key.codeKey)) : '',
                mobileLogin: true,
                veriCode: "", // 短信验证码
                rememberMe:
                    PcCookie.get(Key.passKey) != undefined ? true : false,
            },
            //校验登录信息
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigget: "blur",
                    },
                ],
                veriCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    {
                        len: 6,
                        message: "验证码长度为6位",
                        trigger: "blur"
                    }
                ],
                password: [
                    { required: true, message: "请输入密码", trigget: "blur" },
                ],
            },
            msg: '',
            countDown:0,
        };
    },
    mounted() {
        this.toggleHeaderAndFooter("none");
        window.addEventListener('keyup' ,this.onSubmit,false)
        this.querySystemRemind();
    },
    beforeDestroy() {
        this.toggleHeaderAndFooter("block");
    },
    destroyed(){
        window.removeEventListener('keyup',this.onSubmit,false)
    },
    methods: {
        enterWebsite(src){
            window.open(src, "_blank");
        },
        async querySystemRemind(){
            let res = await getSystemRemind('dltc')
            this.remindData = res.body.data;
            this.dialogVisible = res.body.data.length > 0 ? this.dialogVisible = res.body.data.map(() => true) : this.dialogVisible = res.body.data.map(() => false);
        },
        onSubmit(e){
            if (e.keyCode == 13 ) {
                this.handleLogin('loginForm');
            }
        },
        async sendSmsCode() {
            // 如果正在倒计时，不执行操作
            if (this.countDown > 0) {
                return;
            }

            // 立即开始倒计时
            this.countDown = 60; // 假设倒计时60秒，可根据需求调整
            this.timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) {
                    clearInterval(this.timer);
                    this.countDown = 0;
                }
            }, 1000);

            try {
                const { errorCode, msg } = await sendVeriCode({
                    username: this.loginForm.username,
                    smsType: 'login_bus_sms',
                    phoneNumber: this.loginForm.username
                });

                if (errorCode === '2000') {
                    this.$message.success("验证码发送成功");
                    this.msg = msg;
                } else {
                    // 发送失败，清除计时器并重置倒计时
                    clearInterval(this.timer);
                    this.countDown = 0;
                    this.$message.error(msg || "验证码发送失败");
                }
            } catch (error) {
                // 捕获请求异常，同样清除计时器
                clearInterval(this.timer);
                this.countDown = 0;
                console.error("发送验证码失败:", error);
            }
        },
        //登录
        handleLogin(formName) {
            const key = AES.generatekey(16);
            const password = AES.encrypt(this.loginForm.password,key);
            const loginNews={
                userInfo:{
                    username: this.loginForm.username,
                    password: password,
                    mobileLogin: this.loginForm.mobileLogin,
                    rememberMe: this.loginForm.username,
                    code:key,
                    veriCode: this.loginForm.veriCode
                },
                checked:this.loginForm.rememberMe,
                key:key
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isStatus = true;
                    this.$store
                        .dispatch("UserLogin", loginNews)
                        .then((res) => {
                            const { msg, success, body } = res;
                            if (success) {
                                VueEvent.$emit('passUsrName',body.username);
                                this.$router.push("/pcViews/learn")
                            } else {
                                this.$message({
                                    message: msg,
                                    type: "error",
                                });
                            }
                            this.isStatus = false;
                        })
                        .catch(() => {
                            this.isStatus = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //进入忘记密码
        forgetPassWord() {
            //this.$refs.previewImg.clickHandler();
            this.$router.push("/pcViews/password-find");
        },
        //进入注册页面
        enterRegister() {
            this.$router.push("/pcViews/register");
        },
        //显示、隐藏头部底部
        toggleHeaderAndFooter(displayStr) {
            let header = document.querySelector(".header");
            let footer = document.querySelector(".footer");
            header.style.display = displayStr;
            footer.style.display = displayStr;
        },
    },
};
</script>

<style>
.index-b-nav:hover{
    background: #fff;
    >span{
        color: #0647aa;
    }
    .bNavLeftImg{
        display: block;
    }
    .index-b-nav-s{
        display: flex;
    }
}
.index-b-nav{
    height: 64px;
    padding-left: 34px;
    padding-right: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    >img{
        margin-right: 12px;
    }
    >span{
        font-size: 14px;
        color: #000000;
        line-height: 18px;
    }
    .bNavLeftImg{
        position: absolute;
        left: 0;
        top: 5px;
        display: none;
    }
    .index-b-nav-s{
        position: absolute;
        top: 0;
        left: 264px;
        z-index: 10;
        padding: 7px 5px;
        min-width: 66px;
        background: #fff;
        border:solid 1px rgba(6,71,172,0.8);
        display: none;
        flex-direction: column;
        white-space: nowrap;
        font-size: 12px;
        font-family: "微软雅黑";
        p{
            color: #000000;
            text-align: center;
            line-height: 26px;
            border-bottom: solid 1px #dad7d5;
        }
        p:last-child{
            border: 0;
        }
        p:hover{
            color: #0647aa;
        }
    }
}
.index-banner-nav{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
    width: 264px;
    height: 100%;
    background: rgba(255,255,255,0.8);
    box-shadow: 0px 0px 6px 0 #000;
    display: flex;
    flex-direction: column;
}
.link-container{
    width: 260px;
    height: 440px;
    border-radius: 0 10px 10px 0;
    box-shadow: 0px 0px 6px 0 #000;
    overflow: hidden;
    position: relative;
}

.remember .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #133d93;
    border-color: #133d93;
}
.remember .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #133d93;
}
.remember .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #133d93;
}
.logonContent .el-input__inner {
    color: #8d8d8d;
    background: #f2f2f2;
}
.logonContent .el-input__inner:focus {
    border-color: #133d93;
}
.loginBox .el-dialog__header {
    display: none;
}
.loginBox .el-dialog__body {
    padding: 0;
}
.loginBox .el-dialog {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>

<style lang="less" scoped>
.logonContent .el-button {
    width: 100%;
    height: 42px;
    color: #fff;
    font-size: 16px;
    background: #133d93;
    border-radius: 21px;
    border-color: #133d93 !important;
}
.relevantOperate {
    font-size: 14px;
    font-family: "微软雅黑";
    color: #8d8d8d;
    display: flex;
    flex-direction: row;
    > span {
        font-weight: 700;
        cursor: pointer;
    }
    > span:hover {
        color: #133d93;
    }
    > p {
        margin: 0 12px;
    }
}
.remember {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    // justify-content: space-between;
}
.logonContent {
    flex: 1;
}
.loginFormTitle {
    margin-bottom: 42px;
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
        display: flex;
        flex-direction: column;
        font-size: 20px;
        font-weight: bold;
        color: #133d93;
        line-height: 32px;
        span {
            height: 3px;
            width: 80px;
            background: #133d93;
        }
    }
    > i {
        margin-top: 4px;
        font-size: 26px;
        color: #b1b1b1;
        cursor: pointer;
        font-weight: bold;
    }
}
.loginForm {
    padding: 30px 22px;
    height: 100%;
    border-radius: 0 10px 10px 0;
    display: flex;
    flex-direction: column;
}
.w5 {
    width: 50%;
}
.login {
    width: 460px;
    height: 440px;
    background: #fff;
    border-radius: 10px 0 0 10px;
    display: flex;
    flex-direction: row;
    box-shadow: 0px 0px 6px #000;
    .school {
        height: 100%;
        position: relative;
        > .schoolImg {
            width: 100%;
            height: 100%;
            border-radius: 10px 0 0 10px;
        }
    }
}
.schoolLogo {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 3;
    height: 53px;
}
#loginContaier {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
}
</style>
